<!-- prettier-ignore -->

<div class="actionButtonsRegisterStandalone">
    @if (!isFirstSlide()){
        <button class="cancelButtonRegisterStandalone" (click)="goBack()">{{'Volver' | translate}}</button>
    }
    <button class="continueButtonRegisterStandalone" [disabled]="sendButtonDisabled()" (click)="nextStep()">{{ (isLastSlide() ? 'Enviar' : 'Siguiente') | translate }}</button>
</div>